export default {
  loading(state) {
    return state.loading;
  },

  savedViolationFilters(state) {
    return Object.values(state.savedViolationFilters);
  },

  courseUrlTypeOptions(state) {
    return state.courseUrlTypes.map((courseUrlType) => ({
      value: courseUrlType.id,
      text: courseUrlType.name,
    }));
  },

  courseUrlTypeNameMap(state) {
    return state.courseUrlTypes.reduce(
      (acc, x) => ({
        ...acc,
        [x.id]: x.name,
      }),
      {}
    );
  },

  distributionListMap(state) {
    return new Map(
      state.messageDistributionLists.resources.map((x) => [x.id, x])
    );
  },

  proxyOrganizationsMap(state) {
    return new Map(state.proxyOrganizations.map((x) => [x.id, x]));
  },

  getAccreditingEntityById: (state) => (id) => {
    return state.accreditingEntities.find((ae) => ae.id == id);
  },
};
